module.exports = __webpack_public_path__ + "ffa55aa76a1191964692992b8f2a0c1b.png";